import ChevronDownIcon from "@heroicons/react/24/outline/ChevronDownIcon";
import { useFormContext } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import {
  FieldsetCard,
  getDisabledClasses,
} from "~/common/components/ui/FieldsetCard";
import Input from "~/common/components/ui/Input";
import Select from "~/common/components/ui/select/Select";
import { NOT_AVAILABLE, usaStatesOptions } from "~/common/constants";
import { AccountSchemaType } from "~/patients/utils/PatientSchemas";

interface AddressFieldsetProps {
  disabled?: boolean;
}

export const AddressFieldset = ({ disabled }: AddressFieldsetProps) => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext<AccountSchemaType>();

  return (
    <FieldsetCard
      title="Address"
      disabled={disabled}
      className="border-none p-0 shadow-none"
      contentClassName={twMerge(
        "grid-cols-2 sm:grid-cols-4",
        !disabled && "sm:grid-cols-6",
      )}
    >
      <Input
        id="street"
        label="Street address"
        {...register("addresses.0.street")}
        {...getDisabledClasses(disabled)}
        error={errors?.addresses?.[0]?.street?.message}
        containerClassName={twMerge(!disabled && "sm:col-span-3")}
      />
      <Input
        id="apartment"
        label="Apartment"
        {...register("addresses.0.apartment")}
        {...getDisabledClasses(disabled)}
        error={errors?.addresses?.[0]?.apartment?.message}
        placeholder={disabled ? NOT_AVAILABLE : undefined}
        containerClassName={twMerge(!disabled && "sm:col-span-3")}
      />
      <Input
        id="city"
        label="City"
        {...register("addresses.0.city")}
        {...getDisabledClasses(disabled)}
        error={errors?.addresses?.[0]?.city?.message}
        containerClassName={twMerge(!disabled && "sm:col-span-2")}
      />
      <Select
        error={errors?.addresses?.[0]?.state?.message}
        label="State"
        placeholder={disabled ? NOT_AVAILABLE : "Select state"}
        id="addresses.0.state"
        options={usaStatesOptions}
        control={control}
        containerClassName={twMerge("gap-2", !disabled && "sm:col-span-2")}
        isDisabled={disabled}
        buttonClassName="disabled:bg-transparent disabled:border-none disabled:p-0 disabled:h-auto"
        icon={disabled ? <ChevronDownIcon /> : undefined}
      />
      <Input
        id="zipcode"
        label="ZIP code"
        {...register("addresses.0.zipcode")}
        {...getDisabledClasses(disabled)}
        error={errors?.addresses?.[0]?.zipcode?.message}
        containerClassName={twMerge(!disabled && "sm:col-span-2")}
      />
    </FieldsetCard>
  );
};
